import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
// import '../components/whySlider.css';
// Import your icon images
import img1 from '../assets/images/img1.svg';
import img2 from '../assets/images/img2.svg';
import img3 from '../assets/images/img3.svg';

const WhyChooseSlider = ({ sliders }) => {
  const sliderRef = React.useRef(null);

  const defaultSliderItems = [
    {
      img: img1,
      title: 'Expert Advisor',
      description: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry lorem Ipsum has.'
    },
    {
      img: img2,
      title: 'Easy Process',
      description: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry lorem Ipsum has.'
    },
    {
      img: img3,
      title: 'Fully Controlized',
      description: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry lorem Ipsum has.'
    }
  ];

  const sliderItems = sliders.length > 0 
  ? sliders.map(slider => ({
      img: slider.image || img1,
      title: slider.title || 'Feature',
      description: slider.description || 'Description not available'
    }))
  : defaultSliderItems;

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: true,
    vertical: true,
    verticalSwiping: true,
    arrows: true,
    swipe: true, // Ensure swipe is enabled
    touchThreshold: 5, // Lower threshold for better drag sensitivity
    draggable: true, // Enable drag with mouse
    responsive: [
      {
        breakpoint: 767,
        settings: {
          vertical: true,
          verticalSwiping: true,
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
  };

  const handleDrag = (e) => {
    const slider = sliderRef.current;
    if (!slider) return;

    const startY = e.touches ? e.touches[0].clientY : e.clientY;
    const handleMove = (moveEvent) => {
      const currentY = moveEvent.touches ? moveEvent.touches[0].clientY : moveEvent.clientY;
      const diffY = startY - currentY;
      if (Math.abs(diffY) > 10) { // Threshold for detecting drag
        if (diffY > 0) slider.slickNext();
        else slider.slickPrev();
        document.removeEventListener('mousemove', handleMove);
        document.removeEventListener('touchmove', handleMove);
      }
    };

    document.addEventListener('mousemove', handleMove);
    document.addEventListener('touchmove', handleMove);

    const handleEnd = () => {
      document.removeEventListener('mousemove', handleMove);
      document.removeEventListener('touchmove', handleMove);
      document.removeEventListener('mouseup', handleEnd);
      document.removeEventListener('touchend', handleEnd);
    };

    document.addEventListener('mouseup', handleEnd);
    document.addEventListener('touchend', handleEnd);
  };

  const CustomPrevArrow = (props) => (
    <button
      {...props}
      className="nav-btn top"
      aria-label="Previous"
    >
      <svg viewBox="0 0 70 70" width="70" height="70">
        <path d="M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z" />
      </svg>
    </button>
  );

  const CustomNextArrow = (props) => (
    <button
      {...props}
      className="nav-btn bottom"
      aria-label="Next"
    >
      <svg viewBox="0 0 70 70" width="70" height="70">
        <path d="M12 16l-6-6 1.41-1.41L12 13.17l4.59-4.58L18 10z" />
      </svg>
    </button>
  );

  return (
    <div className="slider-container" onMouseDown={handleDrag} onTouchStart={handleDrag}>
      <div className="slider-wrapper">
        <Slider {...settings} ref={sliderRef} prevArrow={<CustomPrevArrow />} nextArrow={<CustomNextArrow />}>
          {sliderItems.map((item, index) => (
            <div className="slide" key={index}>
              <div className="img-wrapper">
                <img src={item.img} alt={item.title} />
              </div>
              <div className="content">
                <h3 className="">{item.title}</h3>
                <p className="mb-0">{item.description}</p>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default WhyChooseSlider;